<template>
    <section>
        <h1 class="section-title">{{ $t('identityProvider:error:title') }}</h1>
        <div class="alert alert-danger fade show" role="alert">
            <i class="material-icons">warning</i>
            <span>{{ errorInstructions }}</span>
        </div>
    </section>
</template>

<styles>
</styles>

<script>
  export default {
    data: () => ({
      model: {
      },
      disabled: false
    }),
    computed: {
      errorInstructions() {
        const tpl = this.$t('identityProvider:error:instructions');
        const supportName = this.$t('identityProvider:tenant:supportName');
        const supportPhone = this.$t('identityProvider:tenant:customerServicePhoneNumber');
        return tpl.replace('{0}', supportName).replace('{1}', supportPhone);
      }
    },
    async mounted () {
    }
  };
</script>